export const FIELD_MAP = [
  {header: 'Question', prop: 'question'},
  {header: 'Right Answer', prop: 'rightAnswer'},
  {header: 'Wrong Answer 1', prop: 'wrongAnswer1'},
  {header: 'Wrong Answer 2', prop: 'wrongAnswer2'},
  {header: 'Wrong Answer 3', prop: 'wrongAnswer3'}
];

export const buildTemplateHeaders = (languages) =>
  FIELD_MAP.flatMap((f) => languages.map((lang) => `${f.header} ${lang.code}`));
